import { useEffect } from 'react'


const useBodyOverflowHidden = (haveBodyOverflowHidden, classNames = 'body') => {
  const handleBodyOverFlow = (className, exiting) => {
    const elem = document.querySelector(className)
    if(elem && elem.classList) {
      if(!exiting && haveBodyOverflowHidden) {
        elem.classList.add('bodyOverflowHidden')
      } else {
        elem.classList.remove('bodyOverflowHidden')
      }
    }
  }

  const manageBodyOverflow = () => {
    if(classNames && Array.isArray(classNames)) {
      classNames.map(className => handleBodyOverFlow(className))
    } else {
      handleBodyOverFlow(classNames)
    }
  }

  useEffect(() => {
    manageBodyOverflow(classNames, false)
    return () => {
      manageBodyOverflow(classNames, true)
    }
  }, [haveBodyOverflowHidden])
}

// eslint-disable-next-line react/prop-types
export const BodyOverflowHidden = ({ haveBodyOverflowHidden }) => {
  useBodyOverflowHidden(haveBodyOverflowHidden)
  return null
}

export default useBodyOverflowHidden
